/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

/* Home / hero images */
import heroHotel from "../img/hotel.jpg";
import heroHospital from "../img/hospital.jpg";
import heroTeaGarden from "../img/teagarden.jpg";
import heroJewellery from "../img/jwl.jpg";
import heroRestaurant from "../img/rest.jpg";
import heroRetail from "../img/retail1.jpg";
import softwareImage from "../img/ak1.png";
import infrastructureImage from "../img/ak2.png";

/* Product.js images incorporated into Home page */
import productBanner from "../img/e1.jpg";
import retailImage from "../img/retail.jpg";
import hotelImage from "../img/h1.jpg";
import hospitalImage from "../img/h2.jpg";
import teaSofImage from "../img/h3.jpg";
import jewSofImage from "../img/jwl1.jpg";
import pharmaImage from "../img/h4.jpg";
import teaSaleImage from "../img/h5.jpg";
import restaurantImage from "../img/h6.jpg";
import bakeryImage from "../img/h7.jpg";
import pathologyImage from "../img/h9.jpg";
import transportImage from "../img/h10.jpg";
import payHrImage from "../img/h11.jpg";
import newsImage from "../img/h12.jpg";

import "../style/styles.css";
import "../style/Footer.css";
import "../style/HomeProductEnquiry.css";
import "../style/HomeHeroLinks.css";
import "../style/Home.css";

const FALLBACK_IMAGE = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='520' viewBox='0 0 900 520'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' x2='1' y1='0' y2='1'%3E%3Cstop offset='0' stop-color='%23f8fafc'/%3E%3Cstop offset='1' stop-color='%23eef2f7'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='900' height='520' fill='url(%23g)'/%3E%3Crect x='34' y='34' width='832' height='452' rx='28' fill='%23ffffff' stroke='%23e2e8f0' stroke-width='4'/%3E%3Ctext x='450' y='245' text-anchor='middle' font-family='Arial, sans-serif' font-size='34' font-weight='700' fill='%230f172a'%3EEBS Software Solution%3C/text%3E%3Ctext x='450' y='295' text-anchor='middle' font-family='Arial, sans-serif' font-size='22' fill='%2364758b'%3EBusiness Software Solutions%3C/text%3E%3C/svg%3E";

function Home() {
  const navigate = useNavigate();

  const slides = [
    {
      image: heroRetail,
      title: "SaleSync",
      category: "Retail POS & Inventory Software",
      tags: ["POS", "GST Billing", "Live Stock", "MIS Reports"],
      description:
        "GST-ready touch-enabled retail POS software for fast billing, credit GST billing, purchase tracking, stock adjustment, physical stock taking, minimum stock alerts and retail MIS reports.",
      primary: "Explore SaleSync",
      link: "/Retails",
      featureLabel: "SaleSync Retail POS",
      featureTitle: "Inventory + POS + GST + MIS",
      featureText:
        "A practical retail management system for retail outlets, supermarkets, grocery stores, garments shops, electronics stores and other counters that need faster billing and better stock control.",
      featureHighlights: [
        { value: "POS", label: "Touch Billing" },
        { value: "GST", label: "Ready Invoices" },
        { value: "Stock", label: "Live Inventory" },
        { value: "MIS", label: "Business Reports" },
      ],
    },
    {
      image: heroTeaGarden,
      title: "TeaSof",
      category: "Industry Software • ERP • GST • POS",
      tags: ["Tea Garden ERP", "Android Attendance", "Automation"],
      description:
        "Purpose-built Tea Garden ERP with Android attendance, face recognition and plucking weight machine integration for higher accuracy and lower manual effort.",
      primary: "Explore TeaSof",
      link: "/teasof",
      featureLabel: "TeaSof Tea Garden ERP",
      featureTitle: "Garden + Factory + Payroll + Accounts",
      featureText:
        "A complete tea garden software workflow for worker wages, Kamjari analysis, garden activity, factory management, inventory, attendance automation and management reports.",
      featureHighlights: [
        { value: "ERP", label: "Garden Control" },
        { value: "HR", label: "Worker Wages" },
        { value: "Auto", label: "Attendance" },
        { value: "MIS", label: "Reports" },
      ],
    },
    {
      image: heroHotel,
      title: "HotelSof",
      category: "Hotel • Resort • Restaurant • GST",
      tags: ["PMS", "POS", "Billing"],
      description:
        "Complete hotel and resort management software for reservation, check-in, checkout, restaurant billing, accounts and daily operational control.",
      primary: "Explore HotelSof",
      link: "/Hotelsof",
      featureLabel: "HotelSof PMS",
      featureTitle: "Reservation + Front Office + POS + Accounts",
      featureText:
        "A complete PMS workflow for room reservation, guest check-in, checkout, restaurant POS, billing, accounts and hotel management reporting.",
      featureHighlights: [
        { value: "PMS", label: "Room Control" },
        { value: "POS", label: "Restaurant" },
        { value: "GST", label: "Billing" },
        { value: "MIS", label: "Daily Reports" },
      ],
    },
    {
      image: heroJewellery,
      title: "JewSof",
      category: "Jewellery ERP • Barcode • GST",
      tags: ["Gold", "Silver", "Diamond"],
      description:
        "Trusted jewellery ERP for GST billing, barcode, stock, manufacturing, customer order, sales return, accounts and Tally export.",
      primary: "Explore JewSof",
      link: "/jewsof",
      featureLabel: "JewSof Jewellery ERP",
      featureTitle: "Barcode + Stock + Billing + Tally Export",
      featureText:
        "Designed for jewellery businesses to manage gold, silver, diamond, ornaments, customer orders, GST billing, barcode stock and accounting control.",
      featureHighlights: [
        { value: "Gold", label: "Jewellery" },
        { value: "Code", label: "Barcode" },
        { value: "GST", label: "Invoice" },
        { value: "Tally", label: "Export" },
      ],
    },
    {
      image: heroRestaurant,
      title: "RestaurSof",
      category: "Restaurant POS • KOT • Billing",
      tags: ["KOT", "Table Billing", "Settlement"],
      description:
        "Restaurant POS software for KOT, table service, room service, billing, settlement, kitchen workflow and restaurant reports.",
      primary: "Explore RestaurSof",
      link: "/restaurant",
      featureLabel: "RestaurSof Restaurant POS",
      featureTitle: "KOT + Table Billing + Kitchen + Reports",
      featureText:
        "A restaurant management system for order taking, KOT/BOT, table billing, room service, settlement, inventory and GST reports.",
      featureHighlights: [
        { value: "KOT", label: "Kitchen Order" },
        { value: "POS", label: "Billing" },
        { value: "GST", label: "Tax Ready" },
        { value: "MIS", label: "Reports" },
      ],
    },
    {
      image: heroHospital,
      title: "WardMaster",
      category: "Hospital Management Software",
      tags: ["Patient", "Ward", "Billing"],
      description:
        "Hospital information software for patient registration, ward management, billing, reporting and healthcare administration.",
      primary: "Explore WardMaster",
      link: "/Hospital",
      featureLabel: "WardMaster Healthcare Software",
      featureTitle: "Patient + Ward + Billing + Reports",
      featureText:
        "Hospital and nursing home management software for patient registration, IPD, OPD, pharmacy, diagnostics, ward billing and administration.",
      featureHighlights: [
        { value: "IPD", label: "Indoor" },
        { value: "OPD", label: "Outdoor" },
        { value: "Ward", label: "Control" },
        { value: "Bill", label: "Accounts" },
      ],
    },
  ];

  const products = [
    {
      title: "SaleSync",
      subtitle: "Software for Retail OutLet",
      category: "Retail",
      image: retailImage,
      imageAlt: "SaleSync Retail Outlet Software",
      link: "/Retails",
      description:
        "Software for retail settings that uses touchscreen devices such as tablets, POS systems or kiosks to expedite business operations. It improves inventory control, sales transactions, customer engagement and day-to-day retail activity with a user-friendly interface.",
    },
    {
      title: "HotelSof",
      subtitle: "Software for Hotel, Resorts, Motels",
      category: "Hospitality",
      image: hotelImage,
      imageAlt: "HotelSof Hotel Resort Motels Software",
      link: "/Hotelsof",
      description:
        "HotelSof is a complete property management system for hotels, motels and resorts. It includes integrated modules for room reservation, front office, food and beverage POS, accounting and complete operational management.",
    },
    {
      title: "JewSof",
      subtitle: "GST enabled Jewellery Software",
      category: "Jewellery",
      image: jewSofImage,
      imageAlt: "JewSof Jewellery Software",
      link: "/jewsof",
      description:
        "JewSof is a trusted and proven jewellery software package. Its advanced report utility helps analyze business performance, increase sales volume and manage crucial jewellery business data without compromise.",
    },
    {
      title: "TeaSof",
      subtitle: "Tea Garden Software",
      category: "Tea Garden",
      image: teaSofImage,
      imageAlt: "TeaSof Tea Garden Software",
      link: "/teasof",
      description:
        "TeaSof is specially developed for tea gardens. It covers worker wages, Kamjari analysis, garden activity, staff and sub-staff salary, factory management, accounting, inventory control and attendance automation.",
    },
    {
      title: "TeaSale",
      subtitle: "Software for Tea Traders along with blending",
      category: "Tea Trade",
      image: teaSaleImage,
      imageAlt: "TeaSale Tea Traders Blending Software",
      link: "/teasale",
      description:
        "TeaSale is developed for tea manufacturers and traders. It covers billing, stock controlling, blending, auction sales and advanced report utilities for analyzing business performance and profitability.",
    },
    {
      title: "WardMaster",
      subtitle: "Complete Software solution for Hospital / Nursing",
      category: "Healthcare",
      image: hospitalImage,
      imageAlt: "WardMaster Hospital Nursing Software",
      link: "/Hospital",
      description:
        "WardMaster is powerful, flexible and easy to use hospital management software. It covers IPD, OPD, X-ray, scan and diagnostic reports, pharmacy, store control, payroll and complete accounting.",
    },
    {
      title: "Pharmacist",
      subtitle: "Software for Medicine Distributor and Retailers",
      category: "Pharma",
      image: pharmaImage,
      imageAlt: "Pharmacist Medicine Distributor Retailer Software",
      link: "/pharma",
      description:
        "An integrated accounting and inventory control system for medicine distributors and retailers with batch-wise stock, near expiry alerts, profit analysis, slow moving item statements, sales and purchase analysis.",
    },
    {
      title: "RestaurSof",
      subtitle: "GST Enabled Software for Restaurant and Pubs",
      category: "Restaurant",
      image: restaurantImage,
      imageAlt: "RestaurSof Restaurant Pubs Software",
      link: "/restaurant",
      description:
        "RestaurSof manages restaurant operations including order taking, KOT/BOT, billing, reporting, inventory, recipe management, GST reports and financial accounting. Web and desktop versions are available.",
    },
    {
      title: "BakeryPro",
      subtitle: "GST Enabled Software for Bakery Management",
      category: "Bakery",
      image: bakeryImage,
      imageAlt: "BakeryPro Bakery Management Software",
      link: "/bakery",
      description:
        "BakeryPro is integrated software for bakery industries. It supports order management, production, delivery, inventory and customer engagement to make bakery operations more systematic.",
    },
    {
      title: "PathoSof",
      subtitle: "Software for Pathology reports, Billing and Accounting",
      category: "Diagnostics",
      image: pathologyImage,
      imageAlt: "PathoSof Pathology Diagnostic Software",
      link: "/pathology",
      description:
        "PathoSof helps reception staff start patient registration and billing from day one. The software calculates bills, discounts and balances, and generates lab reports automatically with added tests.",
    },
    {
      title: "TransportPro",
      subtitle: "Complete Web Application for Transport Solution",
      category: "Transport",
      image: transportImage,
      imageAlt: "TransportPro Transport Solution",
      link: "/transport",
      description:
        "TransportPro is a full featured web application for goods and courier transportation services. It helps manage transportation operations, billing and business growth from one platform.",
    },
    {
      title: "PayHR",
      subtitle: "Software for Payroll and HR",
      category: "HR / Payroll",
      image: payHrImage,
      imageAlt: "PayHR Payroll HR Software",
      link: "/paysof",
      description:
        "PayHR is a complete payroll management system with biometric attendance support. It helps HR departments manage payroll, attendance and reporting with trusted and proven software features.",
    },
    {
      title: "NewsPro",
      subtitle: "News Papers Accounting with ABC circulation",
      category: "News",
      image: newsImage,
      imageAlt: "NewsPro Newspaper Accounting Software",
      link: "/newssof",
      description:
        "NewsPro is an integrated system for newspapers covering circulation accounts, outstanding analysis, inventory control, advertisement modules, market selling reports, growth reports and ABC analysis.",
    },
  ];

  const serviceItems = [
    "Software installation and implementation",
    "Project management of the implementation process",
    "Training of management and staff",
    "Site customization and software development",
    "Ongoing software upgrades and technical support",
    "Scheduled training courses and operational guidance",
  ];

  const whyChooseUs = [
    "Ready-made and fully customized business software.",
    "GST-enabled billing, stock and reporting workflow.",
    "User-friendly software designed for daily business operations.",
    "Flexible customization according to organization concept.",
    "Domain, hosting, website and web application development.",
    "Reliable post-implementation support and upgrade service.",
    "Cost-effective service and product model.",
    "Export data into Tally ERP / Tally Prime from our software.",
  ];

  const stats = [
    { value: "ERP", label: "Business Automation" },
    { value: "GST", label: "Ready Billing" },
    { value: "POS", label: "Counter & KOT" },
    { value: "24x7", label: "Support Focus" },
  ];

  const industries = [
    "Retail",
    "Hotel",
    "Jewellery",
    "Tea Garden",
    "Restaurant",
    "Hospital",
    "Pharma",
    "Transport",
  ];


  const businessKeywords = [
    "Software company in India",
    "Software Development company in West Bengal, India",
    "Software company in Siliguri",
    "Tea garden software in India",
    "PMS Software in India",
    "PMS Software in West Bengal",
    "ERP PMS Software in West Bengal, India",
    "Retail POS Software",
    "Retail Billing Software",
    "Retail Software in India",
    "Retail Software in Siliguri",
    "Retail Software in West Bengal",
    "GST Billing Software",
    "Inventory Management Software",
    "Hotel Software in India",
    "Restaurant Software in Siliguri",
    "Jewellery Software in India",
    "Customised Software India",
    "Web Development Company in Siliguri",
    "Payment Gateway Integration Company in Siliguri",
  ];

  const implementationSteps = [
    {
      title: "Requirement Study",
      text: "We understand your business process, department workflow and reporting requirement.",
    },
    {
      title: "Implementation",
      text: "Software setup, master configuration, user training and live operational guidance.",
    },
    {
      title: "Customization",
      text: "Additional reports, modules and workflow changes according to business concept.",
    },
    {
      title: "Support",
      text: "Ongoing technical support, upgrades and practical operational assistance.",
    },
  ];

  const createProductEnquiryLink = (product) => {
    const params = new URLSearchParams({
      product: product.title,
      category: product.category,
      subtitle: product.subtitle,
    });

    return `/product-enquiry?${params.toString()}`;
  };

  const handleImageError = (event) => {
    const img = event.currentTarget;

    /*
      Important:
      Do not use another imported image as fallback here.
      If any hosted image is missing/cached incorrectly, the browser can keep
      retrying and it looks like the image/card is blinking.
      This inline SVG fallback loads instantly and stops the retry loop.
    */
    img.onerror = null;
    img.classList.add("ebs-img-fallback");
    img.src = FALLBACK_IMAGE;
  };

  return (
    <main className="ebs-home-match">
      <section className="ebs-current-hero">
        <Carousel interval={7000} pause="hover" touch controls indicators>
          {slides.map((slide, index) => (
            <Carousel.Item key={index}>
              <div className="ebs-current-slide">
                <img
                  className="ebs-current-bg"
                  src={slide.image}
                  alt={`${slide.title} Software`}
                  onError={handleImageError}
                />
                <div className="ebs-current-overlay"></div>

                <Container className="ebs-current-container">
                  <Row className="align-items-center ebs-hero-row">
                    <Col lg={7}>
                      <div className="ebs-hero-copy">
                        <div className="ebs-category-pill">{slide.category}</div>

                        <h1>{slide.title}</h1>
                        <p>{slide.description}</p>

                        <div className="ebs-tag-row">
                          {slide.tags.map((tag) => (
                            <span key={tag}>{tag}</span>
                          ))}
                        </div>

                        <div className="ebs-hero-buttons">
                          <button
                            type="button"
                            className="ebs-btn-orange ebs-hero-route-btn"
                            onClick={() => navigate(slide.link)}
                          >
                            {slide.primary}
                          </button>
                          <a href="#products" className="ebs-btn-outline-light">
                            View Products
                          </a>
                          <a href="#contact-home" className="ebs-btn-light-soft">
                            Request Demo
                          </a>
                        </div>
                      </div>
                    </Col>

                    <Col lg={5} className="d-none d-lg-block">
                      <div className="ebs-hero-feature-card">
                        <span className="ebs-hero-feature-label">
                          {slide.featureLabel}
                        </span>
                        <h2>{slide.featureTitle}</h2>
                        <p>{slide.featureText}</p>
                        <div className="ebs-hero-mini-grid">
                          {slide.featureHighlights.map((item) => (
                            <div key={item.label}>
                              <strong>{item.value}</strong>
                              <small>{item.label}</small>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      <section className="ebs-brand-strip" aria-label="EBS key solution areas">
        <Container>
          <div className="ebs-strip-grid">
            {stats.map((item) => (
              <div className="ebs-strip-card" key={item.value}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="ebs-industry-section">
        <Container>
          <div className="ebs-industry-card">
            <div>
              <span className="ebs-small-title">Industry Solutions</span>
              <h2>Software designed around real business operations</h2>
            </div>
            <div className="ebs-industry-list">
              {industries.map((industry) => (
                <span key={industry}>{industry}</span>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <section className="ebs-products-section" id="products">
        <Container>
          <div className="ebs-product-banner">
            <img
              src={productBanner}
              alt="EBS Software Products"
              onError={handleImageError}
            />
            <div className="ebs-product-banner-content">
              <span>Our Products</span>
              <h2>Ready-made and customized software products from EBS</h2>
              <p>
                Explore GST-enabled software for retail, hotel, jewellery, tea
                garden, hospital, pharmacy, restaurant, payroll, transport and
                other business operations.
              </p>
            </div>
          </div>

          <div className="ebs-section-heading-row">
            <div>
              <span className="ebs-small-title">Product Portfolio</span>
              <h2 className="ebs-section-title">Choose your business software</h2>
            </div>
            <p>
              Every card keeps your existing product route and product enquiry
              route exactly as per your current technical method.
            </p>
          </div>

          <div className="ebs-home-product-grid">
            {products.map((product) => (
              <article className="ebs-home-product-card" key={product.title}>
                <div className="ebs-home-product-img-wrap">
                  <img
                    src={product.image}
                    alt={product.imageAlt}
                    onError={handleImageError}
                  />
                  <span>{product.category}</span>
                </div>

                <div className="ebs-home-product-body">
                  <h3>{product.title}</h3>
                  <h4>{product.subtitle}</h4>
                  <p>{product.description}</p>
                </div>

                <div className="ebs-home-product-footer ebs-home-product-footer-two">
                  <Link to={product.link} className="ebs-home-product-btn">
                    View Product
                  </Link>

                  <Link
                    to={createProductEnquiryLink(product)}
                    className="ebs-home-product-enquiry-btn"
                  >
                    Product Enquiry
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </Container>
      </section>

      <section className="ebs-about-section" id="about">
        <Container>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <div className="ebs-content-panel">
                <span className="ebs-small-title">Software Development</span>
                <h2 className="ebs-section-title">
                  Corporate software solutions for modern organizations
                </h2>
                <p className="ebs-section-text">
                  EBS Software Solution provides business software solutions for
                  hotels, restaurants, jewellery outlets, hospitals, tea gardens
                  and customized ERP requirements. We focus on practical
                  workflow, accurate reporting and reliable day-to-day business
                  control.
                </p>
                <p className="ebs-section-text">
                  We offer complete services covering installation, training,
                  implementation, modification, upgrading and ongoing support.
                  Our software is GST-enabled and can be customized according to
                  your business process.
                </p>

                <div className="ebs-about-points">
                  <div>
                    <span>✓</span>
                    <p>Industry-specific business software</p>
                  </div>
                  <div>
                    <span>✓</span>
                    <p>GST billing, stock and accounts workflow</p>
                  </div>
                  <div>
                    <span>✓</span>
                    <p>Implementation, training and support</p>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="ebs-image-card">
                <img
                  src={softwareImage}
                  alt="Software Development"
                  onError={handleImageError}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="ebs-infra-section">
        <Container>
          <Row className="align-items-center g-5">
            <Col lg={6} className="order-lg-1 order-2">
              <div className="ebs-image-card ebs-image-card-dark">
                <img
                  src={infrastructureImage}
                  alt="IT Infrastructure"
                  onError={handleImageError}
                />
              </div>
            </Col>

            <Col lg={6} className="order-lg-2 order-1">
              <span className="ebs-small-title">IT Infrastructure</span>
              <h2 className="ebs-section-title">
                Secure and scalable technology for business growth
              </h2>
              <p className="ebs-section-text">
                We help businesses improve their IT infrastructure through
                practical software planning, implementation, customization,
                monitoring and support. Our solutions are designed for stability,
                security and future expansion.
              </p>

              <div className="ebs-feature-grid">
                <div>
                  <h4>Scalable</h4>
                  <p>Software that grows with your business.</p>
                </div>
                <div>
                  <h4>Secure</h4>
                  <p>Better control over your business data.</p>
                </div>
                <div>
                  <h4>Reliable</h4>
                  <p>Stable systems for daily operations.</p>
                </div>
                <div>
                  <h4>Supported</h4>
                  <p>Training, upgrades and technical support.</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="ebs-process-section">
        <Container>
          <div className="ebs-center-heading">
            <span className="ebs-small-title">Implementation Method</span>
            <h2 className="ebs-section-title">
              A practical process from requirement to live support
            </h2>
          </div>

          <Row className="g-3">
            {implementationSteps.map((item, index) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="ebs-process-card">
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="ebs-service-section">
        <Container>
          <div className="ebs-center-heading">
            <span className="ebs-small-title">Complete Service</span>
            <h2 className="ebs-section-title">
              EBS Software offers a complete service package
            </h2>
          </div>

          <Row className="g-3">
            {serviceItems.map((item, index) => (
              <Col lg={4} md={6} key={index}>
                <div className="ebs-service-card">
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <p>{item}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="ebs-erp-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="ebs-info-panel">
                <span>ERP Implementation</span>
                <h3>Integrated process control from one platform</h3>
                <p>
                  ERP helps businesses replace disconnected processes with
                  integrated workflow for stock, finance, payroll,
                  manufacturing, distribution and reporting. We assist with
                  planning, implementation and customization.
                </p>
              </div>
            </Col>

            <Col lg={6}>
              <div className="ebs-info-panel ebs-info-panel-dark">
                <span>Innovative Approach</span>
                <h3>Consulting from concept to deployment</h3>
                <p>
                  Our consulting services cover requirement study, architecture,
                  software development, quality assurance, deployment, training
                  and support to deliver practical business solutions.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="ebs-why-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={4}>
              <div className="ebs-why-title">
                <span className="ebs-small-title">Why Choose Us?</span>
                <h2 className="ebs-section-title">
                  Dependable software partner for your business
                </h2>
                <p>
                  We combine domain knowledge, practical software design and
                  support commitment to deliver business-ready applications.
                </p>
              </div>
            </Col>

            <Col lg={8}>
              <Row className="g-3">
                {whyChooseUs.map((item, index) => (
                  <Col md={6} key={index}>
                    <div className="ebs-why-card">
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="ebs-contact-section" id="contact-home">
        <Container>
          <div className="ebs-contact-card">
            <div>
              <span>Need software for your business?</span>
              <h2>Get ready-made or customized software from EBS.</h2>
              <p>
                We provide implementation, training, customization and ongoing
                technical support for your business software.
              </p>
            </div>
            <Link to="/EmailContactForm" className="ebs-btn-white">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="ebs-industry-section" aria-label="EBS software keywords">
        <Container>
          <div className="ebs-industry-card">
            <div>
              <span className="ebs-small-title">Business Keywords</span>
              <h2>Software company, PMS, ERP and retail software solutions</h2>
            </div>
            <div className="ebs-industry-list">
              {businessKeywords.map((keyword) => (
                <span key={keyword}>{keyword}</span>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </main>
  );
}

export default Home;
